const jwt_customizer = {
    general: 'Bei der Anpassung des JWT-Tokens ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
    can_not_create_for_admin_tenant: 'Kann keinen JWT-Token-Anpasser für den Admin-Mandanten erstellen.',
};
export default Object.freeze(jwt_customizer);
